import { Auth0Provider as Auth0ProviderReactWrapper } from '@auth0/auth0-react';
import { AUTH0 } from '@monetize/ui/config';
import React, { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { tempRedirectInfoState } from '../store/global.store';

export const Auth0ProviderReact = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const setRedirectInfo = useSetAtom(tempRedirectInfoState);

  const onRedirectCallback = useCallback(
    (appState: any) => {
      if (appState && appState.returnTo) {
        // When auth0 app state contains the redirect info then save it in redirectUrl
        // This will be used on /select-tenant route.
        setRedirectInfo({
          redirectUrl: appState.returnTo,
        });
      }
    },
    [setRedirectInfo],
  );

  return (
    <Auth0ProviderReactWrapper
      domain={AUTH0.domain}
      clientId={AUTH0.clientId}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        audience: AUTH0.apiAudience,
        redirect_uri: AUTH0.callbackUrl,
        scope: AUTH0.scope,
      }}
      // Ensure unrelated oauth flows are not attempted to be pickled up by Auth0
      skipRedirectCallback={!window.location.href.startsWith(AUTH0.callbackUrl)}
    >
      {children}
    </Auth0ProviderReactWrapper>
  );
};
